import type { RouteRecordRaw } from 'vue-router'

import { AdokLayout as Layout } from '@/apps/adok/app/layout'

const SpotsPage = () =>
  import('@/apps/adok/pages/spots').then((m) => m.SpotsPage)

const spotsRoutes: RouteRecordRaw[] = [
  {
    path: '/traffic/spots',
    component: Layout,
    children: [
      {
        path: '',
        name: 'spots',
        component: SpotsPage,
        meta: {
          title: 'Spots'
        }
      },
      {
        // Optional query, invisible from the path: `?platformId=` preselects the website,
        // `?typeId=` the format — both read in `useSpotsPage` (`spotPreset`).
        path: 'new',
        name: 'spots-new',
        component: SpotsPage,
        meta: {
          title: 'New Spot',
          hidden: true
        }
      },
      {
        path: ':spotId/edit',
        name: 'spots-edit',
        component: SpotsPage,
        meta: {
          title: 'Edit Spot',
          hidden: true
        }
      },
      {
        path: ':spotId/clone',
        name: 'spots-clone',
        component: SpotsPage,
        meta: {
          title: 'New Spot',
          hidden: true
        }
      },
      {
        path: ':spotId/creatives',
        name: 'spots-creatives',
        component: SpotsPage,
        meta: {
          title: 'Choose creatives',
          hidden: true
        }
      },
      {
        path: ':spotId/creatives/new',
        name: 'spots-creative-new',
        component: SpotsPage,
        meta: {
          title: 'New Creative',
          hidden: true
        }
      },
      {
        path: ':spotId/creatives/:creativeId/edit',
        name: 'spots-creative-edit',
        component: SpotsPage,
        meta: {
          title: 'Edit Creative',
          hidden: true
        }
      },
      {
        path: ':spotId/deals/new',
        name: 'spots-deal-new',
        component: SpotsPage,
        meta: {
          title: 'New Deal',
          hidden: true
        }
      }
    ]
  }
]

export default spotsRoutes
